module.exports = __webpack_public_path__ + "static/worldRanks-6e0a5cf0336fd30f0e2d6ee89d651d69.jpg";